import { useQuery } from '@apollo/client';
import React from 'react';
import { gql } from '../../graphql/generated';
import PostDetailPreview from '../../post/PostDetailPreview';
import parseExternalPostId from '../../utils/parseExternalPostId';

const POST_QUERY = gql(/** @complexity 1 */ `
  query ExternalPostDetailPreview($platform: String!, $externalId: ID!) {
    post: externalPost(platform: $platform, externalId: $externalId) {
      id
    }
  }
`);

interface ExternalPostDetailPreviewProps {
  id: string;
  onPreviewLoadChange: (isLoaded: boolean) => void;
}

const ExternalPostDetailPreview = ({
  id,
  onPreviewLoadChange,
}: ExternalPostDetailPreviewProps) => {
  const { externalId, platform, anchor } = parseExternalPostId(id) ?? {};
  const { data } = useQuery(POST_QUERY, {
    fetchPolicy: 'cache-first',
    variables: {
      // @ts-expect-error
      externalId,
      // @ts-expect-error
      platform,
    },
  });

  return data?.post ? (
    <PostDetailPreview
      postId={data.post.id}
      anchor={anchor}
      open
      onPreviewLoadChange={onPreviewLoadChange}
    />
  ) : null;
};

export default ExternalPostDetailPreview;
